import React from 'react';
import { StarIcon } from 'lucide-react';
import { Button } from './Button';
const INC_5000_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/sXTDsich9PaBHm5nXyo3m7/Inc.-5000-Color-Medallion-Logo.png';
const G2_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/uVB5XhjS12ej5LbmT6xbsF/G2_Crowd_logo.svg';
export function FinalCta() {
  return <section className="w-full border-b-2 border-brand-blue bg-black text-white" data-id="element-68" data-mp="15c2ct4olafps">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-id="element-69" data-mp="1jbtxfo9m2ucr">
        <div className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-70" data-mp="1eetsxhsetznr">
          <h2 className="font-display text-5xl uppercase leading-[0.9] sm:text-6xl lg:text-7xl" data-id="element-71" data-mp="1t2ol8x2ia20b">
            Ready to see your numbers move?
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg" data-id="element-72" data-mp="1o4n3cfgtg8qf">
            Free 15-minute call. We look at your funnel, your offer, and where the next dollar comes from.
          </p>
          <div className="mt-8" data-id="element-73" data-mp="1x2gnyt57xdxr">
            <Button variant="primary" data-id="element-74" data-mp="n64b3n7yhqle">Book a Call</Button>
          </div>
        </div>

        <div className="mx-auto mt-20 grid max-w-5xl gap-5 text-left lg:grid-cols-[1.15fr_0.85fr] lg:gap-6" data-id="element-75" data-mp="s4p9dh3ne077">
          <section aria-label="Inc. 5000 recognition" className="grid overflow-hidden border border-white/15 sm:grid-cols-2" data-id="element-76" data-mp="x420wf5grvg4">
            <Recognition year="2024" data-id="element-77" data-mp="123wmc36gzsts" />
            <Recognition year="2025" data-id="element-78" data-mp="120sdgsi288ws" />
          </section>

          <section aria-labelledby="g2-heading" className="border border-white/15 p-6 sm:p-7" data-id="element-79" data-mp="163fcbdd5eu3h">
            <div className="flex items-start justify-between gap-5" data-id="element-80" data-mp="1b2i59zfut9v3">
              <div data-id="element-81" data-mp="1fujpc7j9k4vo">
                <img src={G2_LOGO_URL} alt="G2 Crowd" className="h-10 w-auto object-contain object-left" data-id="element-82" data-mp="1fu05gla1z6f0" />
                <h3 id="g2-heading" className="mt-5 font-mono-eyebrow text-[10px] font-semibold uppercase tracking-[0.18em] text-brand-blue" data-id="element-83" data-mp="1ksbg2y869kya">Verified reviews</h3>
              </div>
              <div className="text-right" data-id="element-84" data-mp="1ttjd7cyycfqs">
                <div className="font-display text-5xl leading-none text-white" data-id="element-85" data-mp="1tuaxvsr0gt2a">4.6</div>
                <div className="mt-2 flex justify-end gap-0.5 text-brand-blue" aria-label="4.6 out of 5 rating" data-id="element-86" data-mp="3qv70gb47286a">
                  {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-87" data-mp="3i4lkim56so0" />)}
                </div>
              </div>
            </div>
            <p className="mt-7 max-w-sm text-sm leading-relaxed text-white/60" data-id="element-88" data-mp="dfsjtiiyiiax">
              Rated by verified G2 users for the workflow, support, and clarity that help teams keep growth moving.
            </p>
          </section>
        </div>
      </div>
    </section>;
}
interface RecognitionProps {
  year: string;
}
function Recognition({
  year
}: RecognitionProps) {
  return <article className="border-b border-white/15 p-6 last:border-b-0 sm:border-b-0 sm:border-r sm:last:border-r-0 sm:p-7" data-id="element-89" data-mp="id14bprkuyfc">
      <span className="font-mono-eyebrow text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-blue" data-id="element-90" data-mp="2k6iaep027r7z">Recognition</span>
      <img src={INC_5000_LOGO_URL} alt="Inc. 5000 America's Fastest-Growing Private Companies" className="mt-5 h-20 w-20 object-contain object-left" data-id="element-91" data-mp="2a3czhyrrhnwv" />
      <div className="mt-4 font-mono-eyebrow text-xs font-semibold uppercase tracking-[0.16em] text-white/70" data-id="element-92" data-mp="20d0ds387nop5">{year}</div>
      <p className="mt-4 max-w-[13rem] text-sm leading-relaxed text-white/55" data-id="element-93" data-mp="25aadqct87ir8">Named to the Inc. 5000 list of America’s fastest-growing private companies.</p>
    </article>;
}